module.exports = __webpack_public_path__ + "static/media/wind-icon.e06d0b80.svg";